export const AboutUsData = [{
'gr':{
  id: 1,
  title: 'Σχετικά με το έργο',
  text:`
<div>
  O παρόν δικτυακός τόπος, explorechania.gr, αναπτύχθηκε στο πλαίσιο του έργου 
  <strong>«Αξιοποίηση καινοτόμων εφαρμογών ΤΠΕ για την ανάδειξη του τουριστικού και πολιτιστικού πλούτου των Χανίων» του Δήμου Χανίων». </strong>
  
  Χρηματοδοτήθηκε από το ΕΠ «Κρήτη» 2014-2020 (MIS :5030576, ΣΑΕΠ 002/1: 2019ΕΠ00210023) από την Ευρωπαϊκή Ένωση - Ευρωπαϊκό Ταμείο Περιφερειακής Ανάπτυξης (ΕΤΠΑ) και από εθνικούς πόρους .
</div>
<div>
  Το έργο αυτό με δικαιούχο τον Δήμο Χανίων, βασίζεται στη διαδημοτική συνεργασία όλων των Δήμων της Περιφερειακή Ενότητας (Π.Ε.) Χανίων και της Εφορείας Αρχαιοτήτων Χανίων.
</div>
<div>
  Στοχεύει στην από κοινού ολοκληρωμένη προβολή και ανάδειξη του πολιτιστικού και τουριστικού αποθέματος των επτά (7) Δήμων της Π.Ε Χανίων (Αποκορώνου, Γαύδου, Καντάνου - Σελίνου, Κισσάμου, Πλατανιά, Σφακίων και Χανίων), μέσα από ένα σύνολο καινοτόμων και συνδυαστικών ψηφιακών δράσεων, που παρέχουν νέες δυνατότητες προβολής του πολιτιστικού και τουριστικού περιεχομένου, στους κατοίκους και επισκέπτες των Χανίων.
  </div>
<div>
  Δείτε περισσότερες πληροφορίες πλαίσιο για το έργο εδώ: 
  <a href="https://www.chania.gr/enimerosi/erga-espa/ris-app-TPE-chania.html" target="_blank" style="color: rgb(10, 85, 114);
  text-decoration: underline;">
  «Αξιοποίηση καινοτόμων εφαρμογών ΤΠΕ για την ανάδειξη του τουριστικού και πολιτιστικού πλούτου των Χανίων» του Δήμου Χανίων»
</a>
</div>

`
  },
  
'en':{
  id: 2,
  title: 'About us',
  text:`
<div>
  O παρόν δικτυακός τόπος, explorechania.gr, αναπτύχθηκε στο πλαίσιο του έργου «Αξιοποίηση καινοτόμων εφαρμογών ΤΠΕ για την ανάδειξη του τουριστικού και πολιτιστικού πλούτου των Χανίων» του Δήμου Χανίων».  Χρηματοδοτήθηκε από το ΕΠ «Κρήτη» 2014-2020 (MIS :5030576, ΣΑΕΠ 002/1: 2019ΕΠ00210023) από την Ευρωπαϊκή Ένωση - Ευρωπαϊκό Ταμείο Περιφερειακής Ανάπτυξης (ΕΤΠΑ) και από εθνικούς πόρους .
</div>
<div>
  Το έργο αυτό με δικαιούχο τον Δήμο Χανίων, βασίζεται στη διαδημοτική συνεργασία όλων των Δήμων της Περιφερειακή Ενότητας (Π.Ε.) Χανίων και της Εφορείας Αρχαιοτήτων Χανίων.
</div>
<div>
  Στοχεύει στην από κοινού ολοκληρωμένη προβολή και ανάδειξη του πολιτιστικού και τουριστικού αποθέματος των επτά (7) Δήμων της Π.Ε Χανίων (Αποκορώνου, Γαύδου, Καντάνου - Σελίνου, Κισσάμου, Πλατανιά, Σφακίων και Χανίων), μέσα από ένα σύνολο καινοτόμων και συνδυαστικών ψηφιακών δράσεων, που παρέχουν νέες δυνατότητες προβολής του πολιτιστικού και τουριστικού περιεχομένου, στους κατοίκους και επισκέπτες των Χανίων.
  </div>
<div>
  Δείτε περισσότερες πληροφορίες πλαίσιο για το έργο εδώ: «Αξιοποίηση καινοτόμων εφαρμογών ΤΠΕ για την ανάδειξη του τουριστικού και πολιτιστικού πλούτου των Χανίων» του Δήμου Χανίων»
</div>
 
  `
},
'bg':{
  id: 3,
  title: 'About us', 
  text:`
<div>
  O παρόν δικτυακός τόπος, explorechania.gr, αναπτύχθηκε στο πλαίσιο του έργου «Αξιοποίηση καινοτόμων εφαρμογών ΤΠΕ για την ανάδειξη του τουριστικού και πολιτιστικού πλούτου των Χανίων» του Δήμου Χανίων».  Χρηματοδοτήθηκε από το ΕΠ «Κρήτη» 2014-2020 (MIS :5030576, ΣΑΕΠ 002/1: 2019ΕΠ00210023) από την Ευρωπαϊκή Ένωση - Ευρωπαϊκό Ταμείο Περιφερειακής Ανάπτυξης (ΕΤΠΑ) και από εθνικούς πόρους .
</div>
<div>
  Το έργο αυτό με δικαιούχο τον Δήμο Χανίων, βασίζεται στη διαδημοτική συνεργασία όλων των Δήμων της Περιφερειακή Ενότητας (Π.Ε.) Χανίων και της Εφορείας Αρχαιοτήτων Χανίων.
</div>
<div>
  Στοχεύει στην από κοινού ολοκληρωμένη προβολή και ανάδειξη του πολιτιστικού και τουριστικού αποθέματος των επτά (7) Δήμων της Π.Ε Χανίων (Αποκορώνου, Γαύδου, Καντάνου - Σελίνου, Κισσάμου, Πλατανιά, Σφακίων και Χανίων), μέσα από ένα σύνολο καινοτόμων και συνδυαστικών ψηφιακών δράσεων, που παρέχουν νέες δυνατότητες προβολής του πολιτιστικού και τουριστικού περιεχομένου, στους κατοίκους και επισκέπτες των Χανίων.
  </div>
<div>
  Δείτε περισσότερες πληροφορίες πλαίσιο για το έργο εδώ: «Αξιοποίηση καινοτόμων εφαρμογών ΤΠΕ για την ανάδειξη του τουριστικού και πολιτιστικού πλούτου των Χανίων» του Δήμου Χανίων»
</div>
  `
}}
]
